import * as React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import SubtitlesOutlinedIcon from '@mui/icons-material/SubtitlesOutlined';
import config from '../../config';

export const SubtitleDownloadButton = ({ clip }) => {

    return (
        <Tooltip title='下载字幕' arrow>
            <IconButton 
                size='small' 
                component='a' 
                href={`${config.url.api}/clips/${clip.id}/srt`} 
                target='_blank'
                sx={{
                    color: 'text.secondary',
                    '&:hover': {
                        color: 'primary.main',
                        bgcolor: 'rgba(255, 139, 147, 0.08)',
                    },
                }}
            >
                <SubtitlesOutlinedIcon sx={{ fontSize: '1.125rem' }} />
            </IconButton>
        </Tooltip>
    );
}